import React, { useEffect } from "react";
import { TbDeviceMobileCancel, TbDeviceMobileUp } from "react-icons/tb";
import { BsDatabaseFillAdd } from "react-icons/bs";
import { PiHandWithdrawFill } from "react-icons/pi";
import { BiSolidCoupon } from "react-icons/bi";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getWalletBalance } from "./services/wallet.services";
import { formatIndianNumber } from "../../_helpers/formatUtils";
import Loading from "../../components/spinner/Loading";
import { setWalletIndex } from "./walletSlice";
import AddBalance from "./AddBalance";
import AddBalanceViaGiftCode from "./AddBalanceViaGiftCode";
import WalletWithdrawalForm from "./WalletWithdrawalForm";
import { useNavigate } from "react-router";

const Wallet: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state.wallet.loading);
  const paymentLoading = useAppSelector(
    (state) => state.reviewbooking.paymentLoading
  );
  const walletDetails = useAppSelector((state) => state.wallet.walletDetails);
  const walletIndex = useAppSelector((state) => state.wallet.walletIndex);

  useEffect(() => {
    dispatch(getWalletBalance());
  }, []);

  return (
    <>
      <Loading loading={loading || paymentLoading} />
      <div className="wallet-page">
        <div className="container">
          <div className="row">
            <div className="col-12 wallet-main-card">
              <div className="d-lg-flex justify-content-between">
                <div>
                  <div>
                    <h4 className="d-flex align-items-center gap-2">
                      Wallet Balance
                    </h4>
                    <h1
                      style={{
                        color: "#00a34d",
                      }}
                    >
                      ₹ {formatIndianNumber(walletDetails?.wallet_balance)}
                    </h1>
                  </div>
                  <div className="d-flex gap-3 mt-4 justify-content-between">
                    <div className="d-flex gap-2">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          minWidth: "40px",
                          background: "#e0f8ec",
                          borderRadius: "5px",
                        }}
                      >
                        <TbDeviceMobileUp
                          style={{ fontSize: 40, color: "#00a34d" }}
                        />
                      </div>
                      <div>
                        <h6 className="">Withdrawal Bal.</h6>
                        <p
                          className="mb-0"
                          style={{
                            color: "#00a34d",
                          }}
                        >
                          ₹{" "}
                          {formatIndianNumber(
                            walletDetails?.refundable_walletamount
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          minWidth: "40px",
                          background: "#e0f8ec",
                          borderRadius: "5px",
                        }}
                      >
                        <TbDeviceMobileCancel
                          style={{ fontSize: 40, color: "#00a34d" }}
                        />
                      </div>
                      <div>
                        <h6 className="">Non Withdrawal Bal.</h6>
                        <p
                          className="mb-0"
                          style={{
                            color: "#00a34d",
                          }}
                        >
                          ₹{" "}
                          {formatIndianNumber(
                            walletDetails?.non_refundable_walletamount
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-3 mt-3 justify-content-between">
                    <span className="fw-600 fs-6">
                      <a
                        href="javascript:void(0)"
                        onClick={() => navigate("/wallettransctionshistory")}
                      >
                        View Transctions
                      </a>
                    </span>
                    <span className="fw-600 fs-6">
                      <a
                        href="javascript:void(0)"
                        onClick={() => navigate("/topuphistory")}
                      >
                        Top-up Request
                      </a>
                    </span>
                  </div>
                </div>

                <div className="d-flex gap-3 mt-4 mt-lg-0 justify-content-between">
                  <div
                    className="wallet-cards"
                    onClick={() => dispatch(setWalletIndex(1))}
                  >
                    <span>
                      <BsDatabaseFillAdd className="card-icon" />
                    </span>
                    <h4 className="mt-3 text-center">Add Balance</h4>
                  </div>
                  <div
                    className="wallet-cards"
                    onClick={() => dispatch(setWalletIndex(2))}
                  >
                    <span>
                      <PiHandWithdrawFill className="card-icon" />
                    </span>
                    <h4 className="mt-3 text-center">
                      Wallet Withdrawal Request
                    </h4>
                  </div>
                  <div
                    className="wallet-cards"
                    onClick={() => dispatch(setWalletIndex(3))}
                  >
                    <span>
                      <BiSolidCoupon className="card-icon" />
                    </span>
                    <h4 className="mt-3 text-center">Wallet Coupon Redeem</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {walletIndex === 1 && <AddBalance />}
          {walletIndex === 2 && <WalletWithdrawalForm />}
          {walletIndex === 3 && <AddBalanceViaGiftCode />}
        </div>
      </div>
    </>
  );
};

export default Wallet;
